// npm imports
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// component imports
import { Toastr } from "../../../revvComponents";
import AddEditDropdown from "./AddEditDropdown";
import { UpgradePopUpV2 } from "../../../commonComponents";
import PlanChangeRequest from "../../SettingsWrapper/BillingSettings/PlanChangeRequest";
// action imports
import {
  getAssetStatusListAction,
  getAssetTagListAction,
  updateAssetStatusListAction,
  updateAssetTagsListAction,
  updateAssestStatusAction,
  updateAssetTagAction,
  updateSwimlane,
} from "../../../actions/AssetActions/assetActions";
import {
  updateTemplateTagAction,
  assignUserGroupToTemplateAction,
  getTemplateInitData,
} from "../../../actions/DocumentTemplateActions/templateActions";
import { fetchUserGroupsService } from "../../../actions/UserActions/userService";
// internal imports
import { EVENTS, FEATURES } from "../../../constants";
import { GlobalUtils, AmplitudeUtils } from "../../../utils";
import UserGroupRoles from "../UserGroupRoles";
// destructuring
const { amplitudeLogEvent } = AmplitudeUtils;
const { handleApiErrMsg, isFreeBillingPlan } = GlobalUtils;
const { FEATURES_NAME } = FEATURES;

class DropdownContainer extends Component {
  state = {
    showAddEditContainer: false,
    showLoader: false,
    showUpgradePopop: false,
  };

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
    this._initAssetStatusTagList();
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  /**
   * ::::: INIT_ASSET_STATUS_OR_TAG_LIST :::::
   */
  _initAssetStatusTagList = () => {
    const { type, assetStatusList, assetTagsList } = this.props;
    let decideActionType = null;
    if (type === "status" && assetStatusList && assetStatusList.length === 0) {
      decideActionType = this.props.getAssetStatusListAction;
    } else if (type === "tags" && assetTagsList && assetTagsList.length === 0) {
      decideActionType = this.props.getAssetTagListAction;
    } else if (type === "userGroups") {
      decideActionType = fetchUserGroupsService;
    } else if (type === "swimlanes") {
      decideActionType = this.props.getPipelineLaneValue;
    }
    if (decideActionType) {
      this.setState({ showLoader: true });
      decideActionType()
        .then(() => {
          this.setState({ showLoader: false });
        })
        .catch(error => {
          console.debug(
            `DropdownContainer => _initAssetStatusTagList => => Error : ${error}`,
          );
          Toastr.showToastr({
            type: "failure",
            message: handleApiErrMsg(error),
            timeout: 3000,
          });
          this.setState({ showLoader: false });
        });
    }
  };

  setWrapperRef = node => {
    this.wrapperRef = node;
  };

  handleClickOutside = event => {
    if (this.state.showUpgradePopop) {
      return;
    }

    event.stopPropagation();
    if (
      this.wrapperRef &&
      event.target &&
      event.target.dataset &&
      this.wrapperRef.id !== event.target.dataset.id &&
      !this.wrapperRef.contains(event.target)
    ) {
      this.props.closeDropdownContainer();
    }
  };

  toggleAddEditContainer = () => {
    const { showAddEditContainer } = this.state;
    this.setState({ showAddEditContainer: !showAddEditContainer });
  };

  closeAddEditContainer = () => {
    const { showAddEditContainer } = this.state;
    if (showAddEditContainer) {
      this.setState({ showAddEditContainer: false });
    }
  };

  // make state changes permanent in both containers(from add edit)
  _applyChanges = newList =>
    new Promise((resolve, reject) => {
      const { type } = this.props;
      const newListWithSequence = newList.map((item, index) => ({
        ...item,
        sequence: index,
      }));
      if (type === "status") {
        // make changes to redux state: call update status list service and dispatcher
        this.props
          .updateAssetStatusList(newListWithSequence)
          .then(() => {
            resolve(this.props.assetStatusList);
          })
          .catch(() => {
            reject();
          })
          .finally(() => {
            this.toggleAddEditContainer();
          });
      } else if (type === "tags") {
        // dispatcher for update
        this.props
          .updateAssetTagsList(newListWithSequence)
          .then(() => {
            resolve(this.props.assetTagsList);
          })
          .catch(() => {
            reject();
          })
          .finally(() => {
            this.toggleAddEditContainer();
          });
      }
    });

  _changeDocumentStatus = (docID, item, type, templateId) => {
    if (type === "userGroups") {
      const data = [];
      const stateData = [];
      let newData = [];
      if (
        this.props.templateUsergroups &&
        this.props.templateUsergroups.length > 0
      ) {
        this.props.templateUsergroups.forEach(users => {
          stateData.push(users);
          data.push(users.id);
        });
      }
      if (item) {
        newData = stateData.filter(i => i.id !== item.id);
        newData.push(item);
        data.push(item.id);
      }
      const usergroupIds = { usergroup_ids: data };

      this.props
        .assignUserGroupToTemplateAction(templateId, usergroupIds, newData)
        .then(() => {
          // this.props.closeDropdownContainer();
        })
        .catch(error => {
          console.error(
            "DropdownContainer => _changeUserGroup => assignUserGroupToTemplateAction => Error : ",
            error,
          );
        });

      // this._onInitTemplaes();
    } else if (docID) {
      if (type === "status") {
        const amplitudeObject = {
          oldStatus: this.props.documentStatus
            ? this.props.documentStatus.name
            : "",
          newStatus: item ? item.name : "",
          tag: this.props.documentTags ? this.props.documentTags.name : "",
          initiatedFrom: "Asset",
        };
        this.props
          .updateAssestStatusAction(docID, item)
          .then(() => {
            amplitudeLogEvent(
              EVENTS.EVENT_NAMES.STATUS_CHANGED,
              amplitudeObject,
            );
            this.props.closeDropdownContainer();
          })
          .catch(error => {
            console.error(
              "DropdownContainer => _changeDocumentStatus => updateAssestStatusAction => Error : ",
              error,
            );
          });
      } else if (type === "tags") {
        const amplitudeObject = {
          oldTag: this.props.documentTags && this.props.documentTags.name,
          newTag: item ? item.name : "",
          status: this.props.documentStatus && this.props.documentStatus.name,
        };
        this.props
          .updateAssetTagAction(docID, item)
          .then(() => {
            amplitudeLogEvent(EVENTS.EVENT_NAMES.TAGS_CHANGED, amplitudeObject);
            this.props.closeDropdownContainer();
          })
          .catch(error => {
            console.error("error", error);
          });
      } else if (type === "swimlanes") {
        this.props
          .updateSwimlane(item.pipeline_id, docID, item)
          .then(() => {
            this.props.closeDropdownContainer();
          })
          .catch(error => {
            console.error(
              "DropdownContainer => _changeDocumentStatus => updateAssestStatusAction => Error : ",
              error,
            );
          });
      }
    } else if (templateId) {
      const amplitudeObject = {
        oldTag: this.props.templateTag && this.props.templateTag.name,
        newTag: item ? item.name : "",
        TemplateID: this.props.templateId,
      };
      this.props
        .updateTemplateTagAction(templateId, item)
        .then(() => {
          amplitudeLogEvent(
            EVENTS.EVENT_NAMES.TEMPLATE_TAGS_CHANGED,
            amplitudeObject,
          );
          this.props.closeDropdownContainer();
        })
        .catch(error => {
          console.error(
            "DropdownContainer => _changeDocumentStatus => updateTemplateTagAction => Error : ",
            error,
          );
        });
    }
  };

  deleteUserGroup = (item, templateId) => {
    const data = [];
    const stateData = [];
    if (
      this.props.templateUsergroups &&
      this.props.templateUsergroups.length > 0
    ) {
      this.props.templateUsergroups.forEach(users => {
        stateData.push(users);
        data.push(users.id);
      });
    }
    const tempState = stateData.filter(i => i.id !== item.id);
    const temp = data.filter(i => i !== item.id);

    const usergroupIds = { usergroup_ids: [...temp] };
    this.props.assignUserGroupToTemplateAction(templateId, usergroupIds, [
      ...tempState,
    ]);
  };

  _addNewUsergroup = e => {
    e.preventDefault();
    const currentUrl = this.removeLastDirectoryPartOf(window.location.href);
    window.location.replace(`${currentUrl}/${"settings"}/${"teammates"}`);
  };

  removeLastDirectoryPartOf = url => {
    const newUrl = url.split("/");
    newUrl.pop();
    return newUrl.join("/");
  };

  _togglePopUp = (type, flag) => {
    this.setState({ [type]: flag });
  };

  editOptionShow = (type, addEditLabel, id) => {
    let editValue = null;
    if (type !== "swimlanes") {
      editValue = (
        <div
          onClick={this.toggleAddEditContainer}
          onKeyPress={() => {}}
          data-id={`addedit${id}`}
          role="button"
          tabIndex="0"
          className="dropdowncontainer-addedit-section add-edit-item">
          <i>
            <FontAwesomeIcon icon={["far", "edit"]} />
          </i>

          {addEditLabel}
        </div>
      );
    }
    return editValue;
  };

  render() {
    const {
      // docID,
      showMenu,
      className,
      id,
      type,
      assetStatusList,
      assetTagsList,
      // templateId,
      userGroups,
      documentPipelineLane,
    } = this.props;
    const { showAddEditContainer, showLoader } = this.state;
    let listItems = assetTagsList;
    let addEditLabel = "Manage Tags";
    if (type === "status") {
      listItems = assetStatusList;
      addEditLabel = "Manage Status";
    } else if (type === "userGroups") {
      listItems = userGroups;
      addEditLabel = "New users groups";
    } else if (type === "swimlanes") {
      listItems = documentPipelineLane;
      addEditLabel = "";
    }
    return (
      <Fragment>
        {this.state.showUpgradePopop &&
          (isFreeBillingPlan() ? (
            <UpgradePopUpV2
              type={FEATURES_NAME.TEMPLATES_USERGROUPS}
              onClose={() => this._togglePopUp("showUpgradePopop", false, null)}
            />
          ) : (
            <PlanChangeRequest
              onClose={() => this._togglePopUp("showUpgradePopop", false, null)}
            />
          ))}
        <div
          id={id}
          ref={this.setWrapperRef}
          className={`dropdowncontainer-menu ${
            showMenu ? "show-dropdown-menu" : ""
          } ${type === "userGroups" ? "user-group-width" : ""}`}>
          {/* ------- Loading text section ------- */}
          {showLoader && (
            <div className="dropdowncontainer-loading-text">loading...</div>
          )}
          <div className="dropdown-inner-container ">
            <div className={`${showAddEditContainer ? "hide-tag-menu" : ""}`}>
              {/* ------- List items section ------- */}
              <UserGroupRoles
                type={type}
                listItems={listItems}
                changeDocumentStatus={this._changeDocumentStatus}
                deleteUserGroup={this.deleteUserGroup}
                addNewUsergroup={this._addNewUsergroup}
                togglePopUp={this._togglePopUp}
                {...this.props}
              />
              {type === "userGroups" ? (
                <div className="add-another-usergroup-footer">
                  <div className="add-another-footer-usergroup-wrapper">
                    <div className="add-another-user-btn">
                      <div className="add-another-user-desc">
                        <span
                          className="addeditdropdown-drag-icon"
                          role="img"
                          aria-label="img">
                          💡
                        </span>
                        Only users belonging to <br />
                        the selected user groups can <br />
                        view and use this template
                        <br /> here
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                this.editOptionShow(type, addEditLabel, id)
              )}
              {/* {type === "userGroups" ? (
              <div>
                <span role="img" aria-label="img">
                  💡
                </span>
                Only people belonging to these user groups can view and use this
                template. Learn more here
              </div>
            ) : null} */}
            </div>

            {showAddEditContainer && type !== "swimlanes" && (
              <AddEditDropdown
                id={`addedit${id}`}
                closeAddEditContainer={this.closeAddEditContainer}
                type={type}
                listItems={listItems}
                showMenu={showAddEditContainer}
                className={className}
                applyListChanges={this._applyChanges}
              />
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

DropdownContainer.propTypes = {
  type: PropTypes.string.isRequired,
  showMenu: PropTypes.bool.isRequired,
  closeDropdownContainer: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};

const mapStateToProps = ({
  AssetStore: { assetStatusList, assetTagsList },
  SettingsStore: { userGroups },
}) => ({
  assetStatusList,
  assetTagsList,
  userGroups,
});

const mapDispatchToProps = {
  getAssetStatusListAction,
  getAssetTagListAction,
  updateAssestStatusAction,
  updateTemplateTagAction,
  updateAssetTagAction,
  updateAssetStatusList: updateAssetStatusListAction,
  updateAssetTagsList: updateAssetTagsListAction,
  assignUserGroupToTemplateAction,
  getTemplateInitData,
  updateSwimlane,
};

export default connect(mapStateToProps, mapDispatchToProps)(DropdownContainer);
